import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useAppDispatch } from '../../../store/hooks';
import { setSidebar } from '../../../store/sidebarDrawer';
import { DrawerComponents } from '../PageLayout';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
        padding: theme.spacing(0, 1),
        backgroundColor: theme.palette.sidebarHeader.main,
    },
    heading: {
        color: theme.palette.secondary.contrastText,
        textTransform: 'capitalize',
    },
    iconButton: {
        '& .MuiSvgIcon-root': {
            fill: theme.palette.secondary.contrastText,
        },
    },
}));

interface Props {
    drawerComponent: DrawerComponents | null;
}

export default function SidebarDrawerHeader({ drawerComponent }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const [heading, setHeading] = React.useState<string>('');

    React.useEffect(() => {
        if (!!drawerComponent) {
            setHeading(drawerComponent);
        }
    }, [drawerComponent]);

    const handleClose = () => {
        dispatch(setSidebar({ active: null }));
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" className={classes.root}>
            <Grid item xs={true}>
                <Typography component="h3" variant="h5" className={classes.heading}>
                    {heading}
                </Typography>
            </Grid>
            <Grid item xs="auto">
                <Tooltip title="Close">
                    <IconButton size="small" onClick={handleClose} className={classes.iconButton}>
                        <MenuOpenIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
}
